class BuildABox extends HTMLElement {
	constructor() {
		super();

    this.buildABox = this.querySelector('.build-a-box');
    this.allSteps = this.querySelectorAll('[data-step]');
    this.currentStep = this.querySelector('[data-step]:not(.d-none)');
    this.allNextSteps = this.querySelectorAll('[data-next-step]');
    this.allPrevSteps = this.querySelectorAll('[data-prev-step]');
    this.funnelType = this.getAttribute('data-funnel-type');

    // step 1
    this.allSubscriptionProducts = this.querySelectorAll('[data-subscription-product-id]');
    this.dynamicNextSteps = this.querySelector('[data-dynamic-next-step]');

    // step 2
    this.allSubscriptionProductWrappers = this.querySelectorAll('[data-step-freq-product]');
    this.allSubscriptionVariants = this.querySelectorAll('[data-subscription-variant-id]');
    this.allSubscriptionFreqWrappers = this.querySelectorAll('[data-variant-freq-wrapper]');

    // step 3
    this.allPrCollectionWrappers = this.querySelectorAll('[data-collection-wrapper]');
    this.allBabAddToCartButtons = this.querySelectorAll('[data-bab-add-to-cart]');
    this.allBottleCountWrappers = this.querySelectorAll('[data-bottle-count]');
    this.allBottleCountPrWrappers = this.querySelectorAll('[data-bottle-count-wrapper]');
    this.babGrandTotal = this.querySelector('[data-bab-grand-total]');
    this.allProductQtyIncreaseButtons = this.querySelectorAll('[data-increase-quantity]');
    this.allProductQtyDecreaseButtons = this.querySelectorAll('[data-decrease-quantity]');
    this.allProductCardQtyInput = this.querySelectorAll('[data-bab-product-card-quantity-input]');
    this.allBabProductAddToCartWrappers = this.querySelectorAll('[data-bab-prd-add-to-cart-wrapper]');

    // step 4
    this.allOnehopeBundleProductModals = this.querySelectorAll('[data-onehope-bundle-product-modal]');
    this.allOnehopeBundleProductViewItems = this.querySelectorAll('[data-onehope-bundle-product-view-item]');
    this.allOnehopeBundleModalCloseButtons = this.querySelectorAll('[data-onehope-bundle-modal-close]');
    this.allOnehopeBundleModalOverlays = this.querySelectorAll('[data-onehope-bundle-modal-overlay]');
    this.allOnehopeBundleCollectionProductIds = this.querySelectorAll('[data-onehope-bundle-collection-product-id]');
    this.allOnehopeBundleFreqSelectionWrappers = this.querySelectorAll('[data-onehope-bundle-freq-selection-wrapper]');
    this.allOnehopeBundleFreqSelectionSubProductIds = this.querySelectorAll('[data-onehope-bundle-freq-selection-sub-product-id]');
    this.allOnehopeBundleFreqSelectionSubProductSellingPlanIds = this.querySelectorAll('[data-onehope-bundle-freq-selection-sub-product-selling-plan-id]');

    // step 5
    this.cartItemsWrapper = this.querySelector('[data-cart-items-wrapper]');
    this.oneTimeMembershipFee = this.querySelector('[data-one-time-membership-fee]');
    this.wineSubtotal = this.querySelector('[data-wine-subtotal]');
    this.wineClubSavings = this.querySelector('[data-wine-club-savings]');
    this.wineClubSavingsWrapper = this.querySelector('[data-wine-club-savings-wrapper]');
    this.subtotal = this.querySelector('[data-subtotal]');
    this.stepCheckout = this.querySelector('[data-step-checkout]');
    this.reviewPageBackStep = this.querySelector('[data-review-page-back-step]');
    this.bundleMinQty = this.querySelector('[data-bundle-min-qty]');
    this.bundleMinQtyWrapper = this.querySelector('[data-bundle-min-qty-wrapper]');

    this.bundleType = null;
    this.tempMainProductId = null;
    this.selectedProduct = null;
    this.selectedProductHandle = null;
    this.selectedProductTitle = null;
    this.selectedVariant = null;
    this.selectedVariantTitle = null;
    this.selectedFrequency = null;
    this.selectedSellingPlanId = null;
    this.totalQty = 0;
    this.totalMinQty = 0;
    this.totalMaxQty = 0;
    this.isFixQtyBundle = false;
    this.selectedQty = 0;
    this.selectedBabProducts = [];
    this.totalPrice = 0;
    this.totalPriceWithoutDiscount = 0;
    this.subBundleProductsForOnehopeFixedBundle = {};
    this.subBundleProductsForOnehopeFixedBundleWithImg = {};
    this.applicableDiscount = false;
	}

  connectedCallback() {
    this.allNextSteps.forEach(nextStep => nextStep.addEventListener('click', this.babNextStep.bind(this)));
    this.allPrevSteps.forEach(prevStep => prevStep.addEventListener('click', this.babPrevStep.bind(this)));
    this.allSubscriptionProducts.forEach(product => product.addEventListener('click', this.babSelectProduct.bind(this)));
    this.allSubscriptionVariants.forEach(variant => variant.addEventListener('click', this.babSelectVariant.bind(this)));
    this.allSubscriptionFreqWrappers.forEach(freqWrapper => freqWrapper.addEventListener('click', this.babSelectFrequency.bind(this)));
    this.allBabAddToCartButtons.forEach(button => button.addEventListener('click', this.babAddToCart.bind(this)));
    this.stepCheckout.addEventListener('click', this.babCheckout.bind(this));
    this.allOnehopeBundleProductViewItems.forEach(item => item.addEventListener('click', this.babViewOnehopeBundleProduct.bind(this)));
    this.allOnehopeBundleModalCloseButtons.forEach(button => button.addEventListener('click', this.babCloseOnehopeBundleModal.bind(this)));
    this.allOnehopeBundleModalOverlays.forEach(overlay => overlay.addEventListener('click', this.babCloseOnehopeBundleModal.bind(this)));
    this.allOnehopeBundleCollectionProductIds.forEach(product => product.addEventListener('click', this.babSelectOnehopeBundleCollectionProduct.bind(this)));
    this.allOnehopeBundleFreqSelectionSubProductSellingPlanIds.forEach(sellingPlan => sellingPlan.addEventListener('click', this.babSelectOnehopeBundleFreqSelectionSubProductSellingPlan.bind(this)));
    this.allProductQtyIncreaseButtons.forEach(button => button.addEventListener('click', this.babProductQtyChange.bind(this)));
    this.allProductQtyDecreaseButtons.forEach(button => button.addEventListener('click', this.babProductQtyChange.bind(this)));
    this.allProductCardQtyInput.forEach(input => input.addEventListener('change', this.babProductCardQtyChange.bind(this)));
  }

  babNextStep(event) {
    event.preventDefault();
    const nextStep = event.target.closest('[data-next-step]');
    const nextStepNumber = nextStep.getAttribute('data-next-step');
    this.allSteps.forEach(step => step.classList.add('d-none'));
    this.querySelector(`[data-step="${nextStepNumber}"]`).classList.remove('d-none');
    setTimeout(() => {
      this.buildABox.scrollTo({top: 0,behavior: 'smooth'});
    }, 100);
  }

  babPrevStep(event) {
    event.preventDefault();
    const prevStep = event.target.closest('[data-prev-step]');
    const prevStepNumber = prevStep.getAttribute('data-prev-step');
    this.allSteps.forEach(step => step.classList.add('d-none'));
    this.querySelector(`[data-step="${prevStepNumber}"]`).classList.remove('d-none');
    setTimeout(() => {
      this.buildABox.scrollTo({top: 0,behavior: 'smooth'});
    }, 100);
  }

  babSelectProduct(event) {
    event.preventDefault();
    const product = event.target.closest('[data-subscription-product-id]');
    const productId = product.getAttribute('data-subscription-product-id');
    this.allSubscriptionProducts.forEach(product => product.classList.remove('active'));
    product.classList.add('active');
    this.tempMainProductId = productId;
    this.bundleType = product.getAttribute('data-bundle-type');
    const nextStep = product.getAttribute('data-trigger-next-setp');
    this.dynamicNextSteps?.setAttribute('data-next-step', nextStep);
    this.dynamicNextSteps?.classList.remove('disabled');
    this.reviewPageBackStep?.setAttribute('data-prev-step', this.bundleType === 'onehope' ? '4' : '3');
    this.bundleMinQtyWrapper.classList.toggle('d-none', this.bundleType === 'onehope');
    this.enableNextStep(nextStep);
  }

  babSelectVariant(event) {
    event.preventDefault();
    const variant = event.target.closest('[data-subscription-variant-id]');
    const variantId = variant.getAttribute('data-subscription-variant-id');
    const variantTitle = variant.getAttribute('data-subscription-variant-title');
    const productId = variant.getAttribute('data-subscription-product-final-id');
    const productTitle = variant.getAttribute('data-subscription-product-final-title');
    const productHandle = variant.getAttribute('data-subscription-product-final-handle');
    this.applicableDiscount = variant.getAttribute('data-variant-applicable-discount') === 'false' ? false : variant.getAttribute('data-variant-applicable-discount');
    this.allSubscriptionVariants.forEach(variant => variant.classList.remove('active'));
    variant.classList.add('active');
    this.selectedProduct = productId;
    this.selectedProductHandle = productHandle;
    this.selectedProductTitle = productTitle;
    this.selectedVariant = variantId;
    this.selectedVariantTitle = variantTitle;
    this.totalQty = parseInt(variant.getAttribute('data-variant-bottles-count'));
    this.totalMinQty = parseInt(variant.getAttribute('data-variant-bottles-min-count'));
    this.totalMaxQty = parseInt(variant.getAttribute('data-variant-bottles-max-count'));
    this.isFixQtyBundle = variant.getAttribute('data-product-bundle-is-fixed-qty') === 'true' ? true : false;
    this.bundleMinQty.innerHTML = this.totalQty;
    this.enableNextStep('freq_selection');
    if (this.funnelType === "tasting-kit") {
      this.enableNextStep('3');
    }
  }

  babSelectFrequency(event) {
    event.preventDefault();
    const freqWrapper = event.target.closest('[data-variant-freq-wrapper]');
    const sellingPlanId = freqWrapper.getAttribute('data-selling-plan-id');
    this.allSubscriptionFreqWrappers.forEach(freqWrapper => freqWrapper.classList.remove('active'));
    freqWrapper.classList.add('active');
    this.selectedSellingPlanId = sellingPlanId;
    this.selectedFrequency = freqWrapper.querySelector('[data-selling-plan-name]').textContent;
    this.enableNextStep('3');
  }

  babAddToCart(event) {
    event.preventDefault();
    const button = event.target.closest('[data-bab-add-to-cart]');
    const productTitle = button.getAttribute('data-pr-title');
    const variantTitle = button.getAttribute('data-pr-variant-title');
    const productImage = button.getAttribute('data-pr-image');
    const productSubtext = button.getAttribute('data-pr-subtext');
    const productId = button.getAttribute('data-pr-id');
    const variantId = button.getAttribute('data-variant-id');
    const qty = button.getAttribute('data-qty');
    const atcText = button.getAttribute('data-atc-text');
    const addedToCartText = button.getAttribute('data-added-to-cart-text');
    const addedToCart = button.getAttribute('data-bab-added-to-cart');
    const price = button.closest('[data-bab-prd-add-to-cart-wrapper]')?.querySelector(`[data-bab-main-selected-product-id="${this.selectedProduct}"] [data-bab-prd-price-item-variant-id="${this.selectedVariant}"] [data-bab-prd-price-item-variant-discounted-price]`)?.getAttribute('data-bab-prd-price-item-variant-discounted-price') 
                || button.closest('[data-bab-prd-add-to-cart-wrapper]')?.querySelector(`[data-bab-main-selected-product-id="${this.selectedProduct}"] [data-bab-prd-price-item-variant-id="${this.selectedVariant}"] [data-bab-prd-price-item-variant-regular-price]`)?.getAttribute('data-bab-prd-price-item-variant-regular-price');
    const regPrice = button.closest('[data-bab-prd-add-to-cart-wrapper]')?.querySelector(`[data-bab-main-selected-product-id="${this.selectedProduct}"] [data-bab-prd-price-item-variant-id="${this.selectedVariant}"] [data-bab-prd-price-item-variant-regular-price]`)?.getAttribute('data-bab-prd-price-item-variant-regular-price');
    if (addedToCart === 'false') {
      button.setAttribute('data-bab-added-to-cart', 'true');
      button.classList.remove('btn--secondary');
      button.textContent = addedToCartText;
      this.selectedBabProducts.push({
        productTitle: productTitle,
        variantTitle: variantTitle,
        productImage: productImage,
        productSubtext: productSubtext,
        productId: productId,
        variantId: variantId,
        qty: qty,
        price: parseInt(price),
        regPrice: parseInt(regPrice),
      });

      button.closest('[data-bab-prd-add-to-cart-wrapper]').querySelector('input').value = qty;
      button.classList.add('d-none');
      button.closest('[data-bab-prd-add-to-cart-wrapper]').querySelector('[data-bab-quantity-selector]').classList.remove('d-none');
      button.closest('[data-bab-prd-add-to-cart-wrapper]').querySelector('input').dispatchEvent(new Event('change'));
    } else {
      button.classList.add('btn--secondary');
      button.setAttribute('data-bab-added-to-cart', 'false');
      button.textContent = atcText;
      this.selectedBabProducts = this.selectedBabProducts.filter(product => product.productId !== productId);
    }

    // actions after product is added to cart
    this.selectedQty = this.selectedBabProducts.length;
    this.totalPriceWithoutDiscount = this.selectedBabProducts.reduce((acc, product) => acc + (product.regPrice * product.qty), 0);
    if (this.funnelType === "build-a-box" || (this.funnelType === "tasting-kit" && this.bundleType !== "onehope")) {
      this.totalPrice = this.selectedBabProducts.reduce((acc, product) => acc + (product.price * product.qty), 0);
      if(this.funnelType === 'tasting-kit' && this.bundleType !== 'onehope') {
        this.totalPrice = this.totalPrice + this.mainTastingProductData.reduce((acc, product) => acc + (product.price * product.qty), 0);
      }
    } else {
      this.totalPrice = this.totalPriceWithoutDiscount;
    }

    this.renderCart();
  }

  babProductQtyChange(event) {
    event.preventDefault();
    const button = event.target.closest('[data-increase-quantity]') || event.target.closest('[data-decrease-quantity]');
    const action = button.getAttribute('action');
    const input = button.closest('[data-bab-prd-add-to-cart-wrapper]').querySelector('input');
    const qty = parseInt(input.value);
    if (action === 'increase') { input.value = qty + 1; } else { input.value = qty - 1; }
    input.dispatchEvent(new Event('change'));
  }

  babProductCardQtyChange(event) {
    event.preventDefault();
    const input = event.target.closest('[data-bab-product-card-quantity-input]');
    const qty = parseInt(input.value);
    if(qty == 0) {
      const inputWrapper = input.closest('[data-bab-prd-add-to-cart-wrapper]');
      inputWrapper.querySelector('[data-bab-add-to-cart]').classList.remove('d-none');
      inputWrapper.querySelector('[data-bab-quantity-selector]').classList.add('d-none');
      inputWrapper.querySelector('[data-bab-add-to-cart]')?.setAttribute('data-bab-added-to-cart', 'false');
      inputWrapper.querySelector('[data-bab-add-to-cart]')?.classList.add('btn--secondary');
      inputWrapper.querySelector('[data-bab-add-to-cart]').textContent = inputWrapper.querySelector('[data-bab-add-to-cart]').getAttribute('data-atc-text');
    }
    const productId = input.getAttribute('data-bab-qty-product-id');
    const variantId = input.getAttribute('data-bab-qty-variant-id');
    this.selectedBabProducts = this.selectedBabProducts.map(product => {
      if (product.productId === productId && product.variantId === variantId) {
        return { ...product, qty: qty };
      }
      return product;
    });
    this.selectedBabProducts = this.selectedBabProducts.filter(product => product.qty > 0);
    this.selectedQty = this.selectedBabProducts.reduce((acc, product) => acc + product.qty, 0);
    this.totalPriceWithoutDiscount = this.selectedBabProducts.reduce((acc, product) => acc + (product.regPrice * product.qty), 0);
    if (this.funnelType === "build-a-box" || (this.funnelType === "tasting-kit" && this.bundleType !== "onehope")) {
      this.totalPrice = this.selectedBabProducts.reduce((acc, product) => acc + (product.price * product.qty), 0);
      if(this.funnelType === 'tasting-kit' && this.bundleType !== 'onehope') {
        this.totalPrice = this.totalPrice + this.mainTastingProductData.reduce((acc, product) => acc + (product.price * product.qty), 0);
      }
    } else {
      this.totalPrice = this.totalPriceWithoutDiscount;
    }

    this.setupProductSelectionFooter();
    this.renderCart();
  }

  setupProductSelectionFooter() {
    this.babGrandTotal.innerHTML = themeVendor.themeCurrency.formatMoney(this.totalPriceWithoutDiscount, theme.moneyFormat);
    this.allBottleCountWrappers.forEach(wrapper => wrapper.classList.remove('active'));
    this.allBottleCountWrappers.forEach(wrapper => {
      if (parseInt(wrapper.getAttribute('data-bottle-count')) <= this.selectedQty) {
        wrapper.classList.add('active');
      }
    });
    const bottleCountWrapper = this.querySelector('[data-bottle-count-wrapper]:not(.d-none)');
    if(bottleCountWrapper) {
      const bottlesCountInNumber = bottleCountWrapper.querySelector('[data-bab-bottles-additional-count-in-number]');
      const bottlesCount = bottleCountWrapper.querySelectorAll('[data-bottle-count]');
      if(bottlesCountInNumber) {
        var additionalBottlesCount = this.selectedQty - bottlesCount.length;
        if(additionalBottlesCount > 0) {
          bottlesCountInNumber.innerHTML = `+${additionalBottlesCount}`;
        } else {
          bottlesCountInNumber.innerHTML = '';
        }
      }
    }

    // if bundle is fixed qty & selected qty is equal to total qty
    if(this.isFixQtyBundle && this.selectedQty === this.totalQty) {
      this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.remove('disabled'));
      this.allBabAddToCartButtons.forEach(button => button.getAttribute('data-bab-added-to-cart') === 'false' && button.classList.add('disabled'));
      this.allProductQtyIncreaseButtons.forEach(button => button.setAttribute('disabled', 'disabled'));
      this.querySelector('[data-step-checkout]').classList.remove('disabled');
    } else if (!this.isFixQtyBundle) {
      // if bundle is not fixed qty & selected qty is between total min qty and total max qty
      if(this.selectedQty >= this.totalMinQty && this.selectedQty < this.totalMaxQty) {
        this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.remove('disabled'));
        this.allBabAddToCartButtons.forEach(button => button.getAttribute('data-bab-added-to-cart') === 'false' && button.classList.remove('disabled'));
        this.allProductQtyIncreaseButtons.forEach(button => button.removeAttribute('disabled'));
        this.querySelector('[data-step-checkout]').classList.remove('disabled');
      } else if(this.selectedQty == this.totalMaxQty) {
        // if bundle is not fixed qty & selected qty is equal to total max qty
        this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.remove('disabled'));
        this.allBabAddToCartButtons.forEach(button => button.getAttribute('data-bab-added-to-cart') === 'false' && button.classList.add('disabled'));
        this.allProductQtyIncreaseButtons.forEach(button => button.setAttribute('disabled', 'disabled'));
        this.querySelector('[data-step-checkout]').classList.remove('disabled');
      } else if(this.selectedQty > this.totalMaxQty) {
        // if bundle is not fixed qty & selected qty is greater than total max qty
        this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.add('disabled'));
        this.allBabAddToCartButtons.forEach(button => button.getAttribute('data-bab-added-to-cart') === 'false' && button.classList.add('disabled'));
        this.allProductQtyIncreaseButtons.forEach(button => button.setAttribute('disabled', 'disabled'));
        this.querySelector('[data-step-checkout]').classList.add('disabled');
      } else if(this.selectedQty < this.totalMinQty) {
        this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.add('disabled'));
        this.allBabAddToCartButtons.forEach(button => button.getAttribute('data-bab-added-to-cart') === 'false' && button.classList.remove('disabled'));
        this.allProductQtyIncreaseButtons.forEach(button => button.removeAttribute('disabled'));
        this.querySelector('[data-step-checkout]').classList.add('disabled');
      }
    } else {
      // if bundle is not fixed qty & selected qty is less than total min qty
      this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.add('disabled'));
      this.allBabAddToCartButtons.forEach(button => button.getAttribute('data-bab-added-to-cart') === 'false' && button.classList.remove('disabled'));
      this.allProductQtyIncreaseButtons.forEach(button => button.removeAttribute('disabled'));
      this.querySelector('[data-step-checkout]').classList.add('disabled');
    }
  }

  babViewOnehopeBundleProduct(event) {
    event.preventDefault();
    event.stopPropagation();
    const product = event.target.closest('[data-onehope-bundle-product-view-item]');
    const productId = product.getAttribute('data-onehope-bundle-product-id');
    this.allOnehopeBundleProductModals.forEach(modal => modal.classList.remove('open'));
    this.querySelector(`[data-onehope-bundle-modal-product-id="${productId}"]`).classList.add('open');
  }

  babCloseOnehopeBundleModal(event) {
    event.preventDefault();
    this.allOnehopeBundleProductModals.forEach(modal => modal.classList.remove('open'));
  }

  babSelectOnehopeBundleCollectionProduct(event) {
    event.preventDefault();
    const product = event.target.closest('[data-onehope-bundle-collection-product-id]');
    const productId = product.getAttribute('data-onehope-bundle-collection-product-id');
    const qty = product.getAttribute('data-onehope-bundle-collection-product-qty');
    const variantId = product.getAttribute('data-onehope-bundle-collection-product-variant-id');
    const variantTitle = product.getAttribute('data-onehope-bundle-collection-product-variant-title');
    const productTitle = product.getAttribute('data-onehope-bundle-collection-product-title');
    const productImage = product.getAttribute('data-onehope-bundle-collection-product-image');
    const productSubtext = product.getAttribute('data-onehope-bundle-collection-product-subtitle');
    const productPrice = product.getAttribute('data-onehope-bundle-collection-product-price');
    const subBundleProducts = JSON.parse(product.querySelector('script[type="application/json"][data-onehope-bundle-sub-products-qty-json]').innerHTML);
    this.subBundleProductsForOnehopeFixedBundle = subBundleProducts;
    const subBundleProductsJson = JSON.parse(product.querySelector('script[type="application/json"][data-onehope-bundle-sub-products-json]').innerHTML);
    this.subBundleProductsForOnehopeFixedBundleWithImg = subBundleProductsJson;
    this.allOnehopeBundleCollectionProductIds.forEach(product => product.classList.remove('active'));
    this.applicableDiscount = product.getAttribute('data-variant-applicable-discount') === 'false' ? false : product.getAttribute('data-variant-applicable-discount');
    product.classList.add('active');

    this.selectedBabProducts = [];
    this.babSelectedOnehopeBundleMainProduct = {
      productTitle: productTitle,
      variantTitle: variantTitle,
      productImage: productImage,
      productSubtext: productSubtext,
      productId: productId,
      variantId: variantId,
      qty: qty,
      price: parseInt(productPrice)
    };
    Object.values(this.subBundleProductsForOnehopeFixedBundleWithImg).map(subProduct => {
      var prPrice = parseInt(subProduct.regularPrice);
      this.selectedBabProducts.push({
        productTitle: subProduct.title,
        variantTitle: subProduct.variant_title,
        productImage: subProduct.image,
        productSubtext: subProduct.subtitle,
        productId: subProduct.id,
        variantId: subProduct.variant_id,
        qty: subProduct.qty,
        regPrice: this.funnelType === 'tasting-kit' ? 0 : parseInt(subProduct.regularPrice)
      });
    })
    this.totalPrice = parseInt(productPrice);

    this.tempOneHopeMainProductId = product.getAttribute('data-onehope-bundle-collection-product-bab-atc-main-product-id');
    this.selectedProductTitle = product.getAttribute('data-onehope-bundle-collection-product-bab-atc-main-product-title');
    this.selectedProductHandle = product.getAttribute('data-onehope-bundle-collection-product-bab-atc-main-product-handle');
    this.selectedVariant = product.getAttribute('data-onehope-bundle-collection-product-bab-atc-main-product-variant-id');
    this.selectedVariantTitle = product.getAttribute('data-onehope-bundle-collection-product-bab-atc-main-product-variant-title');
    this.isFixQtyBundle = product.getAttribute('data-product-bundle-is-fixed-qty') === 'true' ? true : false;
    this.totalMinQty = product.getAttribute('data-variant-bottles-min-count');
    this.totalMaxQty = product.getAttribute('data-variant-bottles-max-count');
    this.totalQty = product.getAttribute('data-variant-bottles-count'); 

    this.totalPriceWithoutDiscount = this.selectedBabProducts.reduce((acc, product) => acc + (product.regPrice * product.qty), 0);
    if(this.funnelType === 'tasting-kit') {
      this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.remove('disabled'));
      this.selectedBabProducts = this.selectedBabProducts.map(product => {
        return { ...product, price: parseInt(productPrice) };
      });
      this.totalPrice = this.selectedBabProducts.reduce((acc, product) => acc + (product.regPrice * product.qty), 0) + parseInt(productPrice);
      this.babSelectedOnehopeBundleMainProduct.price = this.totalPrice;
      this.renderCart();
    } else {
      this.allOnehopeBundleFreqSelectionWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
      this.querySelector(`[data-onehope-bundle-freq-selection-wrapper][data-onehope-bundle-freq-selection-main-product-id="${this.tempMainProductId}"]`).classList.remove('d-none');
      this.allOnehopeBundleFreqSelectionSubProductIds.forEach(subProduct => subProduct.classList.add('d-none'));
      this.querySelector(`[data-onehope-bundle-freq-selection-sub-product-id="${productId}"]`).classList.remove('d-none');

      setTimeout(() => {
        this.buildABox.scrollTo({
          top: this.buildABox.scrollHeight,
          behavior: 'smooth'
        });
      }, 250);
      this.enableNextStep('onehope_freq_selection');
    }
  }

  babSelectOnehopeBundleFreqSelectionSubProductSellingPlan(event) {
    event.preventDefault();
    const sellingPlan = event.target.closest('[data-onehope-bundle-freq-selection-sub-product-selling-plan-id]');
    const sellingPlanId = sellingPlan.getAttribute('data-onehope-bundle-freq-selection-sub-product-selling-plan-id');
    const price = sellingPlan.querySelector('[data-onehope-bundle-freq-selection-sub-product-selling-plan-price]').getAttribute('data-onehope-bundle-freq-selection-sub-product-selling-plan-price');
    this.allOnehopeBundleFreqSelectionSubProductSellingPlanIds.forEach(sellingPlan => sellingPlan.classList.remove('active'));
    sellingPlan.classList.add('active');
    this.selectedSellingPlanId = sellingPlanId;
    this.selectedFrequency = sellingPlan.querySelector('[data-selling-plan-name]').textContent;
    this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.remove('disabled'));
    this.selectedBabProducts = this.selectedBabProducts.map(product => {
      return { ...product, price: parseInt(price) };
    });
    this.totalPrice = parseInt(price);
    console.log(this.totalPrice, 'helooooooo');
    this.renderCart();
  }

  enableNextStep(step) {
    switch (step) {
      case '2':
        this.selectedProduct = null;
        this.selectedProductHandle = null;
        this.selectedProductTitle = null;
        this.selectedVariant = null;
        this.selectedVariantTitle = null;
        this.selectedFrequency = null;
        this.selectedSellingPlanId = null;
        this.totalQty = 0;
        this.selectedQty = 0;
        this.totalPrice = 0;
        this.totalPriceWithoutDiscount = 0;
        this.querySelector('[data-next-step="2"]').classList.remove('disabled');
        this.querySelector('[data-next-step="3"]').classList.add('disabled');
        this.allSubscriptionProductWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
        var productWrapper = this.querySelector(`[data-step-freq-product="${this.tempMainProductId}"]`);
        productWrapper.classList.remove('d-none');
        this.allSubscriptionVariants.forEach(variant => variant.classList.remove('active'));
        productWrapper.querySelector('[data-subscription-freq-wrapper]').classList.add('d-none');
        productWrapper.querySelector('[data-subscription-freq-wrapper]')?.querySelectorAll(`[data-variant-id]`).forEach(variant => variant.classList.add('d-none'));
        break;
      case 'freq_selection':
        this.selectedFrequency = null;
        this.selectedSellingPlanId = null;
        this.querySelector('[data-next-step="3"]').classList.add('disabled');
        var productWrapper = this.querySelector(`[data-step-freq-product="${this.tempMainProductId}"]`);
        if(this.funnelType === "build-a-box") {
          productWrapper.querySelector('[data-subscription-freq-wrapper]').classList.remove('d-none');
        }
        productWrapper?.querySelectorAll(`[data-variant-id]`).forEach(variant => variant.classList.add('d-none'));
        productWrapper?.querySelector(`[data-variant-id="${this.selectedVariant}"]`)?.classList.remove('d-none');
        productWrapper?.querySelectorAll(`[data-variant-id="${this.selectedVariant}"] [data-variant-freq-wrapper]`).forEach(freqWrapper => freqWrapper.classList.remove('active'));

        this.selectedQty = 0;
        this.totalPrice = 0;
        this.totalPriceWithoutDiscount = 0;
        this.selectedBabProducts = [];
        this.babGrandTotal.innerHTML = themeVendor.themeCurrency.formatMoney(0, theme.moneyFormat);
        if(this.funnelType === 'tasting-kit' && this.bundleType !== 'onehope') {
          const productWrapper = this.querySelector(`[data-subscription-product-final-id="${this.selectedProduct}"]`);
          this.mainTastingProductData = [];
          this.mainTastingProductData.push({
            productTitle: this.selectedProductTitle,
            variantTitle: this.selectedVariantTitle,
            productImage: productWrapper.getAttribute('data-subscription-product-final-image'),
            productSubtext: "",
            productId: this.selectedProduct,
            variantId: this.selectedVariant,
            qty: 1,
            price: parseInt(productWrapper.getAttribute('data-subscription-product-final-price')),
            regPrice: parseInt(productWrapper.getAttribute('data-subscription-product-final-price')),
          });     
          this.babGrandTotal.innerHTML = themeVendor.themeCurrency.formatMoney(this.mainTastingProductData.reduce((acc, product) => acc + (product.regPrice * product.qty), 0), theme.moneyFormat);     
        }
        this.allBottleCountWrappers.forEach(wrapper => wrapper.classList.remove('active'));
        this.allBabAddToCartButtons.forEach(button => {button.classList.remove('disabled'), button.setAttribute('data-bab-added-to-cart', 'false'), button.classList.add('btn--secondary')});
        this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.add('disabled'));

        this.allBabProductAddToCartWrappers.forEach(wrapper => {
          wrapper.querySelectorAll('[data-bab-main-selected-product-id]').forEach(item => item.classList.add('d-none'));
          wrapper.querySelectorAll('[data-bab-main-selected-product-id] [data-bab-prd-price-item-variant-id]').forEach(item => item.classList.add('d-none'));
          wrapper.querySelectorAll(`[data-bab-main-selected-product-id="${this.selectedProduct}"]`).forEach(item => item.classList.remove('d-none'));
          wrapper.querySelectorAll(`[data-bab-main-selected-product-id="${this.selectedProduct}"] [data-bab-prd-price-item-variant-id="${this.selectedVariant}"]`).forEach(item => item.classList.remove('d-none'));
          wrapper.querySelector('[data-bab-product-card-quantity-input]').value = 0;
          wrapper.querySelector('[data-bab-quantity-selector]')?.classList.add('d-none');
          wrapper.querySelector('[data-bab-add-to-cart]').classList.remove('d-none');
          wrapper.querySelector('[data-bab-add-to-cart]').classList.add('btn--secondary');
          wrapper.querySelector('[data-bab-add-to-cart]').textContent = wrapper.querySelector('[data-bab-add-to-cart]').getAttribute('data-atc-text');
        });
        break;
      case '3':
        this.querySelector('[data-next-step="3"]').classList.remove('disabled');
        this.allPrCollectionWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
        var productWrapper = this.querySelector(`[data-pr-collection-wrapper-id="${this.selectedProduct}"]`);
        productWrapper?.classList.remove('d-none');
        this.allBottleCountPrWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
        this.querySelector(`[data-bottle-count-wrapper][data-bottle-count-pr-id="${this.selectedProduct}"][data-bottle-count-variant-id="${this.selectedVariant}"]`).classList.remove('d-none');
        this.renderCart();
        break;
      case '4':
        this.selectedVariant = null;
        this.selectedVariantTitle = null;
        this.selectedFrequency = null;
        this.selectedSellingPlanId = null;
        this.totalQty = 0;
        this.selectedQty = 0;
        this.totalPrice = 0;
        this.totalPriceWithoutDiscount = 0;
        break;
      case 'onehope_freq_selection':
        this.selectedFrequency = null;
        this.selectedSellingPlanId = null;
        this.querySelectorAll('[data-next-step="5"]').forEach(button => button.classList.add('disabled'));
        this.allOnehopeBundleFreqSelectionSubProductSellingPlanIds.forEach(sellingPlan => sellingPlan.classList.remove('active'));
        break;
      default:
        break;
    }
  }

  renderCart() {
    this.cartItemsWrapper.innerHTML = '';
    this.wineSubtotal.innerHTML = themeVendor.themeCurrency.formatMoney(this.totalPriceWithoutDiscount, theme.moneyFormat);
    console.log(this.totalPriceWithoutDiscount, this.totalPrice);
    if(this.totalPriceWithoutDiscount > this.totalPrice && this.funnelType !== 'tasting-kit') {
      this.wineClubSavingsWrapper.classList.remove('d-none');
      this.wineClubSavings.innerHTML = themeVendor.themeCurrency.formatMoney(this.totalPriceWithoutDiscount - this.totalPrice, theme.moneyFormat);
    } else {
      this.wineClubSavingsWrapper.classList.add('d-none');
    }
    const totalPrice = this.totalPrice + parseInt(this.oneTimeMembershipFee?.getAttribute('data-one-time-membership-fee') || 0);
    this.subtotal.innerHTML = themeVendor.themeCurrency.formatMoney(totalPrice, theme.moneyFormat);
    this.bundleMinQtyWrapper.style.color = this.stepCheckout.classList.contains('disabled') ? '#ff0000' : '';

    var productsArray = this.selectedBabProducts;
    if(this.bundleType === 'onehope') {
      productsArray = [this.babSelectedOnehopeBundleMainProduct];
    }


    // for tasting kit, because we need to show one main product of $49 or $98 on summary page
    if(this.funnelType === 'tasting-kit' && this.bundleType !== 'onehope') {
      this.mainTastingProductData.forEach(product => {
        this.cartItemsWrapper.innerHTML += `
        <div class="bab-cart-item flex py-r5">
          <div class="bab-item-img">
            <img src="${product.productImage}" alt="${product.productTitle}" width="118px" height="auto" loading="lazy"  >
          </div>
          <div class="bab-item-details py-r5">
            <div class="bab-items-info mb-r8">
              <div class="bab-item-title-wrapper flex items-center justify-between">
                <span class="bab-item-title text-btn-font font-medium">${product.productTitle}</span>
                <span class="bab-item-price text-btn-font font-medium">${themeVendor.themeCurrency.formatMoney(product.price * product.qty, theme.moneyFormat)}</span>
              </div>
              <div class="bab-item-variant-info text-btn-font text-626262 body-size-2">${product.productSubtext}</div>
              <div class="bab-item-subscription-info text-btn-font text-626262 body-size-2 ${this.funnelType === 'tasting-kit' ? 'd-none' : ''}">Ships ${this.selectedFrequency?.toLowerCase()}</div>
            </div>
          </div>
        </div>
      `;
      })
    }

    productsArray.forEach(product => {
      let optionsHtml = '';
      for (let i = 1; i <= this.totalQty; i++) {
        optionsHtml += `<option value="${i}" ${i === parseInt(product.qty) ? 'selected' : ''}>${i}</option>`;
      }

      var subProductHtml = '';
      if(this.bundleType === 'onehope') {
        for(const subProduct in this.subBundleProductsForOnehopeFixedBundleWithImg) {
          var subProductData = this.subBundleProductsForOnehopeFixedBundleWithImg[subProduct];
        subProductHtml += `
          <div class="bab-item-sub-products flex items-center gap-r5 mb-r4">
            <div class="bab-item-sub-product w-fit">
              <img src="${subProductData.image}" alt="${subProductData.title}" width="30px" height="auto" loading="lazy" >
            </div>
            <div class="bab-item-sub-product-details items-center gap-r1 flex">
              <div class="text-btn-font font-medium">${subProductData.title}: </div>
              <div class="text-btn-font text-626262">${subProductData.qty}</div>
            </div>
          </div>
        `;
        }
      }
      
      this.cartItemsWrapper.innerHTML += `
        <div class="bab-cart-item flex py-r5">
          <div class="bab-item-img">
            <img src="${product.productImage}" alt="${product.productTitle}" width="118px" height="auto" loading="lazy"  >
          </div>
          <div class="bab-item-details py-r5">
            <div class="bab-items-info mb-r8">
              <div class="bab-item-title-wrapper flex items-center justify-between">
                <span class="bab-item-title text-btn-font font-medium">${product.productTitle}</span>
                <span class="bab-item-price text-btn-font font-medium 121111">${themeVendor.themeCurrency.formatMoney((this.funnelType === 'build-a-box' || this.bundleType === 'onehope' || (this.funnelType === 'tasting-kit' && this.bundleType !== 'onehope')) ? product.price * product.qty : product.regPrice * product.qty, theme.moneyFormat)}</span>
              </div>
              <div class="bab-item-variant-info text-btn-font text-626262 body-size-2">${product.productSubtext}</div>
              <div class="bab-item-subscription-info text-btn-font text-626262 body-size-2 ${this.funnelType === 'tasting-kit' ? 'd-none' : ''}">Ships ${this.selectedFrequency?.toLowerCase()}</div>
            </div>
            ${subProductHtml}
            <div class="bab-item-qty-wrapper flex items-center justify-between ${this.bundleType === 'onehope' ? 'd-none' : ''}">
              <div class="bab-item-qty">
                <select class="form-select" data-bab-cart-qty-input data-bab-cart-qty-product-id="${product.productId}" data-bab-cart-qty-variant-id="${product.variantId}">
                  ${optionsHtml}
                </select>
              </div>
              <div class="bab-item-remove cursor-pointer" data-remove-product-from-cart="${product.variantId}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M14 11V17M10 11V17M6 7V19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V7M4 7H20M7 7L9 3H15L17 7" stroke="#31302E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      `;
    });

    this.handleRemoveProductFromCart();
    this.handleCartQtyInput();
  }

  handleCartQtyInput() {
    this.cartQtyInputs = this.querySelectorAll('[data-bab-cart-qty-input]');
    this.cartQtyInputs.forEach(input => input.addEventListener('change', this.babCartQtyChange.bind(this)));
  }

  babCartQtyChange(event) {
    event.preventDefault();
    const input = event.target.closest('[data-bab-cart-qty-input]');
    const productId = input.getAttribute('data-bab-cart-qty-product-id');
    const variantId = input.getAttribute('data-bab-cart-qty-variant-id');
    const qty = parseInt(input.value);

    const collectionWrapper = this.querySelector(`[data-step="3"] [data-pr-collection-wrapper-id]:not(.d-none)`);
    const productWrapper = collectionWrapper.querySelector(`[data-bab-quantity-selector] [data-bab-qty-product-id="${productId}"][data-bab-qty-variant-id="${variantId}"]`);
    productWrapper.value = qty;
    productWrapper.dispatchEvent(new Event('change'));
  }

  handleRemoveProductFromCart() {
    this.removeFromCartButtons = this.querySelectorAll('[data-remove-product-from-cart]');
    this.removeFromCartButtons.forEach(button => button.addEventListener('click', this.removeProductFromCart.bind(this)));
  }

  removeProductFromCart(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.target.closest('[data-remove-product-from-cart]');
    const variantId = button.getAttribute('data-remove-product-from-cart');
    this.selectedBabProducts = this.selectedBabProducts.filter(product => product.variantId !== variantId);
    this.selectedQty = this.selectedBabProducts.length;

    const productCardAtcBtn = this.querySelector(`[data-step="3"] [data-pr-collection-wrapper-id]:not(.d-none) [data-bab-prd-add-to-cart-wrapper] [data-variant-id="${variantId}"]`);
    if(productCardAtcBtn) {
      productCardAtcBtn.classList.add('btn--secondary');
      productCardAtcBtn.textContent = productCardAtcBtn.getAttribute('data-atc-text');
      productCardAtcBtn.setAttribute('data-bab-added-to-cart', 'false');
      productCardAtcBtn.classList.remove('disabled');
      const input = productCardAtcBtn.closest('[data-bab-prd-add-to-cart-wrapper]').querySelector('[data-bab-product-card-quantity-input]');
      input.value = 0;
      input.dispatchEvent(new Event('change'));
    }
  }

  async babCheckout(event) {
    event.preventDefault();
    event.target.closest('[data-step-checkout]')?.classList.add('disabled');
    var bundleUid = this.generateUUID();
    var bundleMatchUniqueId = new Date().getTime();

    // for prefix bundles
    if(this.bundleType === 'onehope') {
      // for fix qty bundles
      if(this.isFixQtyBundle) {
        var items = this.selectedBabProducts.map(product => {
          return {
            id: product.variantId,
            quantity: parseInt(product.qty),
            ...(this.selectedSellingPlanId && { selling_plan: this.selectedSellingPlanId }),
            properties: {
              _bundleMatchUniqueId: bundleMatchUniqueId,
              _bundleUid: bundleUid,
              _bundleHandle: this.selectedProductHandle,
              _bundleType: "dynamicBaB",
              _bundleLabel: this.selectedVariantTitle,
              _bundleProductId: `gid://shopify/Product/${this.tempOneHopeMainProductId}`,
              _bundleName: this.selectedProductTitle,
              _bundleBoxSize: this.totalQty,
              _variantId: `gid://shopify/ProductVariant/${this.selectedVariant}`
            }
          }
        });
      } else {
        // for range qty bundles
        var items = this.selectedBabProducts.map(product => {
          return {
            id: product.variantId,
            quantity: parseInt(product.qty),
            ...(this.selectedSellingPlanId && { selling_plan: this.selectedSellingPlanId }),
            properties: {
              _bundleMatchUniqueId: bundleMatchUniqueId,
              _bundleUid: bundleUid,
              _bundleHandle: this.selectedProductHandle,
              _bundleType: "dynamicBaB",
              _bundleLabel: this.selectedVariantTitle,
              _bundleProductId: `gid://shopify/Product/${this.tempOneHopeMainProductId}`,
              _bundleName: this.selectedProductTitle,
              _bundleBoxMinSize: this.totalMinQty,
              _bundleBoxSize: 0,
              _bundleBoxMaxSize: this.totalMaxQty,
              _variantId: `gid://shopify/ProductVariant/${this.selectedVariant}`
            }
          }
        });
      }

    } else {
      // for custom bundles

      // for fix qty bundles
      if(this.isFixQtyBundle) {
        var items = this.selectedBabProducts.map(product => {
          return {
            id: product.variantId,
            quantity: parseInt(product.qty),
            ...(this.selectedSellingPlanId && { selling_plan: this.selectedSellingPlanId }),
            properties: {
              _bundleMatchUniqueId: bundleMatchUniqueId,
              _bundleUid: bundleUid,
              _bundleHandle: this.selectedProductHandle,
              _bundleType: "dynamicBaB",
              _bundleLabel: this.selectedVariantTitle,
              _bundleProductId: `gid://shopify/Product/${this.selectedProduct}`,
              _bundleName: this.selectedProductTitle,
              _bundleBoxSize: this.totalQty,
              _variantId: `gid://shopify/ProductVariant/${this.selectedVariant}`
            }
          }
        }); 
      } else {
        // for range qty bundles
        var items = this.selectedBabProducts.map(product => {
          return {
            id: product.variantId,
            quantity: parseInt(product.qty),
            ...(this.selectedSellingPlanId && { selling_plan: this.selectedSellingPlanId }),
            properties: {
              _bundleMatchUniqueId: bundleMatchUniqueId,
              _bundleUid: bundleUid,
              _bundleHandle: this.selectedProductHandle,
              _bundleType: "dynamicBaB",
              _bundleLabel: this.selectedVariantTitle,
              _bundleProductId: `gid://shopify/Product/${this.selectedProduct}`,
              _bundleName: this.selectedProductTitle,
              _bundleBoxMinSize: this.totalMinQty,
              _bundleBoxSize: 0,
              _bundleBoxMaxSize: this.totalMaxQty,
              _variantId: `gid://shopify/ProductVariant/${this.selectedVariant}`
            }
          }
        }); 
      }
    }

    if(this.oneTimeMembershipFee != null) {
      items.push({
        id: this.oneTimeMembershipFee.getAttribute('data-one-time-membership-fee-variant-id'),
        quantity: 1,
        properties: {
          _bundleMatchUniqueId: bundleMatchUniqueId,
          _is_one_time_membership_fee: true
        }
      });
    }

    if(this.funnelType === "tasting-kit") {
      items.push({
        id: this.selectedVariant,
        quantity: 1,
        properties: {
          _bundleMatchUniqueId: bundleMatchUniqueId,
          _is_tasting_kit: true,
          _bundleUid: bundleUid,
        }
      });

      if(this.bundleType === 'onehope') {
        items = items.map(item => {
          if(item.properties._is_tasting_kit === undefined) {
            item.properties._isFreeItem = true;
          }
          return item;
        })
      }

      items = items.map(item => {
        if (item.properties && (
          item.properties._bundleBoxSize ||
          item.properties._bundleBoxMinSize ||
          item.properties._bundleBoxMaxSize ||
          item.properties._bundleLabel ||
          item.properties._bundleName ||
          item.properties._bundleProductId || 
          item.properties._bundleType ||
          item.properties._variantId
        )) {
          delete item.properties._bundleBoxSize;
          delete item.properties._bundleBoxMinSize;
          delete item.properties._bundleBoxMaxSize;
          delete item.properties._bundleLabel;
          delete item.properties._bundleName;
          delete item.properties._bundleProductId;
          delete item.properties._bundleType;
          delete item.properties._variantId;
        }
        item.properties._is_tasting_kit_bundle = true;
        return item;
      });

      console.log(items);
    }

    await fetch(`/discount/${this.applicableDiscount}`);
    setLocalStorage('applicableDiscount', 1);
    await fetch('/cart/clear.js');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(res => res.json()).then(data => window.location.href = '/checkout?skip_shopify_pay=true').catch(err => console.log(err));
    // }).then(res => res.json()).then(data => console.log(data)).catch(err => console.log(err));
  }

generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
}

customElements.define('build-a-box', BuildABox);